/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Welcome_BackInputs */

const en_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

const es_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido de nuevo`)
};

const fr_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon retour`)
};

const de_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen zurück`)
};

const ja_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おかえりなさい`)
};

const zh_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎回来`)
};

const ar_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحباً بعودتك`)
};

const id_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selamat datang kembali`)
};

const it_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bentornato`)
};

const ru_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С возвращением`)
};

const pt_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo de volta`)
};

const ko_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 오신 것을 환영합니다`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Auth_Welcome_BackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_welcome_back = /** @type {((inputs?: Auth_Welcome_BackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Welcome_BackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_welcome_back(inputs)
	if (locale === "es") return es_auth_welcome_back(inputs)
	if (locale === "fr") return fr_auth_welcome_back(inputs)
	if (locale === "de") return de_auth_welcome_back(inputs)
	if (locale === "ja") return ja_auth_welcome_back(inputs)
	if (locale === "zh") return zh_auth_welcome_back(inputs)
	if (locale === "ar") return ar_auth_welcome_back(inputs)
	if (locale === "id") return id_auth_welcome_back(inputs)
	if (locale === "it") return it_auth_welcome_back(inputs)
	if (locale === "ru") return ru_auth_welcome_back(inputs)
	if (locale === "pt") return pt_auth_welcome_back(inputs)
	return ko_auth_welcome_back(inputs)
});